import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { Order, ordersApi } from 'api/orders'
import Spinner from 'components/Spinner'
import useFlag from 'hooks/useFlag'
import useFlagsReady from 'hooks/useFlagsReady'
import { buildTranslate } from 'locales'
import { Fields as UserProfile } from 'models/UserProfile'
import React, { useMemo, useState } from 'react'
import OrderDetailsModal from './OrderDetailsModal'
import Table from './Table'

const t = buildTranslate('users.view.activity.orders')

type PropsT = {
  profile: UserProfile
}

const Orders: React.FC<PropsT> = ({ profile }: PropsT) => {
  const [selectedOrder, setSelectedOrder] = useState<Order>()
  const itemsEnabled = useFlag('purchase-linked-pos-order-mx', false)
  const areFlagsReady = useFlagsReady()
  const { data, isLoading, isFetching } = ordersApi.useGetOrdersQuery(
    { userId: profile.id, includeItems: itemsEnabled },
    { skip: !areFlagsReady }
  )

  function handleDetailsClick(order: Order) {
    setSelectedOrder(order)
  }

  const orders = useMemo(
    () =>
      [...(data?.orders ?? [])].sort(
        (a, b) =>
          new Date(b.placed_at).getTime() - new Date(a.placed_at).getTime()
      ),
    [data?.orders]
  )
  const hasMoreOrders = !!data?.has_more_orders
  return (
    <div>
      <div className="d-flex justify-content-between">
        <Text.Header4 className={'mb-m'}>{t('title')}</Text.Header4>
      </div>
      <Spinner
        className="d-flex justify-content-center"
        size="3x"
        isLoading={!areFlagsReady || isLoading || isFetching}
      >
        <Switch
          condition={!!(data && data.orders.length > 0)}
          fallback={
            <Text.BodyText3 color="grey70">{t('empty_state')}</Text.BodyText3>
          }
        >
          <Table orders={orders} onDetailsClick={handleDetailsClick} />
          {hasMoreOrders && (
            <Text.BodyText5 tag="div" color="grey70" className="mt-s">
              {t('truncated', { count: orders.length })}
            </Text.BodyText5>
          )}
        </Switch>
      </Spinner>
      {!!selectedOrder && (
        <OrderDetailsModal
          order={selectedOrder}
          itemsEnabled={itemsEnabled}
          onHide={() => setSelectedOrder(undefined)}
        />
      )}
    </div>
  )
}

export default Orders
